import {
  FaVideo,
  FaHeart,
  FaBolt,
  FaUsers,
  FaClock,
  FaMobileAlt,
  FaEye,
  FaCoins,
} from "react-icons/fa";
import { WHY_CONTEXT_IMAGE } from "../../constants/config";

const ICONS = {
  videocam: FaVideo,
  heart: FaHeart,
  flash: FaBolt,
  people: FaUsers,
  time: FaClock,
  mobile: FaMobileAlt,
  visibility: FaEye,
  economy: FaCoins,
};

export default function ValuePropsSection({
  title,
  stats = [],
  paragraphs = [],
  image,
  imageAlt = "",
  itemsTitle,
  items,
  variant = "candidat",
}) {
  const isCandidat = variant === "candidat";

  const displayImage = image ?? WHY_CONTEXT_IMAGE.src;
  const displayImageAlt = image !== undefined ? imageAlt : WHY_CONTEXT_IMAGE.alt;

  const statValueClass = isCandidat ? "text-brand-primary" : "text-brand-primaryDark";
  const statBgClass = isCandidat
    ? "bg-gradient-to-br from-brand-primary/10 to-brand-accent1/10"
    : "bg-gradient-to-br from-brand-primaryDark/10 to-brand-accent2/10";

  return (
    <div className="container mx-auto max-w-5xl">
      <h2 className="text-2xl sm:text-3xl font-bold text-center mb-8 text-gray-900">
        {title}
      </h2>

      {stats.length > 0 && (
        <div
          className={`grid grid-cols-1 gap-4 mb-8 ${
            stats.length > 1 ? "sm:grid-cols-2" : "max-w-md mx-auto"
          }`}
        >
          {stats.map((stat) => (
            <div
              key={stat.label}
              className={`text-center p-6 rounded-2xl ${statBgClass}`}
            >
              <p className={`text-3xl sm:text-4xl font-bold ${statValueClass}`}>
                {stat.value}
              </p>
              <p className="text-sm mt-2 text-gray-600">{stat.label}</p>
              {stat.source && (
                <p className="text-xs mt-2 text-gray-500">
                  Source :{" "}
                  {stat.sourceUrl ? (
                    <a
                      href={stat.sourceUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="underline hover:opacity-80 text-brand-primaryDark"
                    >
                      {stat.source}
                    </a>
                  ) : (
                    stat.source
                  )}
                </p>
              )}
            </div>
          ))}
        </div>
      )}

      {displayImage && (
        <div className="flex justify-center mb-8">
          <img
            src={displayImage}
            alt={displayImageAlt}
            className="w-full max-w-md sm:max-w-lg h-auto"
          />
        </div>
      )}

      {paragraphs.length > 0 && (
        <div className="space-y-4 leading-relaxed text-center max-w-3xl mx-auto text-gray-600 mb-10">
          {paragraphs.map((paragraph) => (
            <p key={paragraph.slice(0, 40)}>{paragraph}</p>
          ))}
        </div>
      )}

      {itemsTitle && (
        <h3 className="text-xl sm:text-2xl font-bold text-center mb-8 text-gray-900">
          {itemsTitle}
        </h3>
      )}

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {items.map((item) => {
          const Icon = ICONS[item.icon] || FaHeart;
          return (
            <div
              key={item.title}
              className={`p-6 rounded-2xl border ${
                isCandidat
                  ? "bg-gradient-to-br from-brand-primary/5 to-brand-accent1/5 border-brand-secondary/20"
                  : "bg-gradient-to-br from-brand-primaryDark/5 to-brand-accent2/5 border-brand-accent2/20"
              }`}
            >
              <div
                className={`w-12 h-12 rounded-xl flex items-center justify-center mb-4 ${
                  isCandidat
                    ? "bg-brand-primary text-white"
                    : "bg-brand-primaryDark text-white"
                }`}
              >
                <Icon className="text-xl" />
              </div>
              <h4 className="text-lg font-semibold mb-2 text-gray-900">
                {item.title}
              </h4>
              <p className="text-gray-600 text-sm leading-relaxed">
                {item.description}
              </p>
            </div>
          );
        })}
      </div>
    </div>
  );
}
